export enum Modules {
  DASHBOARD = "DASHBOARD",
  USER = "USER",
  TRANSACTION = "TRANSACTION",
  STEAM = "STEAM",
  COMMON = "COMMON",
  CUSTOMER = "CUSTOMER",
  DEVICE = "DEVICE",
  MERCHANT = "MERCHANT",
  BATCHES = "BATCHES",
  ASSET = "ASSET",
  PAYMENT = "PAYMENT",
  MERCHANT_SETTINGS = "MERCHANT_SETTINGS",
  CUSTOMERCONNECT = "CUSTOMERCONNECT",
  TPN = "TPN",
  SETTINGS = "SETTINGS",
  MY_TICKETS = "MY_TICKETS",
  ISO_SETTINGS = "ISO_SETTINGS",
  ISV_SETTINGS = "ISV_SETTINGS",
  CLOUD_POS = "CLOUD_POS",
  CONSUMER = "CONSUMER",
  AUDITLOGS = "AUDITLOGS",
  NOTES = "NOTES",
  TROUBLESHOOT = "TROUBLESHOOT",
  BILLING = "BILLING",
  DEVELOPER_CENTER = "DEVELOPER_CENTER",
  PROMOTION = "PROMOTION",
  INVENTORY = "INVENTORY",
  RENTAL = "RENTAL",
  REPORTS = "REPORTS",
  CUSTOMER_SUPPORT_VIDEOS = "CUSTOMER_SUPPORT_VIDEOS",
  ADVANCED = "ADVANCED",
  RISK_MANAGEMENT = "RISK_MANAGEMENT",
  DV_STORE="DV_STORE",
  BETA_SEARCH="BETA_SEARCH",
  CAMPAIGN="CAMPAIGN",
  MULTI_MID = "MULTI_MID",
  MERCHANT_BILLING = "MERCHANT_BILLING",
  CHATBOT = "CHATBOT",
  COMMAND_CENTER="COMMAND_CENTER",
  COMMUNICATION_CENTER="COMMUNICATION_CENTER",
  CONTROL_CENTER="CONTROL_CENTER",
  DESIGNER_TOOL="DESIGNER_TOOL",
  RESOURCES="RESOURCES",
  INVOICE="INVOICE",
  DEJAUP="DEJA_UP",
  ISV="ISV"
}
